import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const technologyPlatformDefinition: ResourceDefinition = {
  title: 'Technology Platforms',
  nameSingular: 'Technology Platform',
  namePlural: 'Technology Platforms',
  className: 'TechnologyPlatform',
  mainIdentifier: 'name',
  slug: 'taxonomies/technology-platforms',
  path: 'technology-platforms',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (technologyPlatform) => ({
        type: ActionType.Link,
        link: {
          path: `${technologyPlatformDefinition.path}/${technologyPlatform.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (technologyPlatform) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: technologyPlatform,
          definition: technologyPlatformDefinition
        }
      })
    }
  ]
}
